module.exports = __webpack_public_path__ + "img/icon7.eceabbb9.png";